import {Provider} from "@angular/core";
import {CUSTOMER_PAGE_COMPONENT} from "../../../../../features/feature-crm/cr/service/token/customer.token";

import {
    CrCustomerObjectPage
} from "../../../../../features/feature-crm/cr/page/object/cr-customer-object-page/cr-customer-object.page";
import {CONTRACT_PAGE_COMPONENT} from "../../../../../features/feature-crm/cm/service/token/contract.token";
import {CmContractPage} from "../../../../../features/feature-crm/cm/page/overview/cm-contract-page/cm-contract.page";


export const ALPHA_PROVIDERS: Provider[] = [
    {
        provide: CUSTOMER_PAGE_COMPONENT,
        useValue: CrCustomerObjectPage
    },
    {
        provide: CONTRACT_PAGE_COMPONENT,
        useValue: CmContractPage
    }
];